
import { Injectable, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { StorageMap } from '@ngx-pwa/local-storage';
import * as _ from 'lodash';
import * as moment from 'moment';
import * as CryptoJS from 'crypto-js';
import * as S3 from 'aws-sdk/clients/s3';
import { ToastrService } from 'ngx-toastr';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Buffer } from 'buffer';

import { environment } from 'src/environments/environment';
import { MessageService } from 'src/app/modules/shared/services/message.service';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor(
    private _router: Router,
    private _httpClient: HttpClient,
    private _storage: StorageMap,
    private _toastrService: ToastrService,
    private _messageService: MessageService,
    private _deviceDetectorService: DeviceDetectorService
  ) { }

  // Get device type -----------------
  getDeviceType() {
    let deviceInfo = this._deviceDetectorService.getDeviceInfo();

    return deviceInfo.deviceType;
  }

  // Show toast -----------------
  showToast(message: string, title: string, type: 'success' | 'error' | 'info' | 'warning', options:any) {
    // Clear all toast
    this._toastrService.clear();

    if (type == 'success') {
      this._toastrService.success(message, title, options);
    } else if (type == 'error') {
      this._toastrService.error(message, title, options);
    } else if (type == 'info') {
      this._toastrService.info(message, title, options);
    } else if (type == 'warning') {
      this._toastrService.warning(message, title, options);
    }
  }

  // Set storage data -----------------
  setStorageData(key, value) {
    return new Promise(resolve => {
      try {
        this._storage.set(key, value).subscribe(() => {
          resolve(true);
        });
      } catch (error) {
        resolve(false);
      }
    });
  }

  // Get storage data -----------------
  getStorageData(key) {
    return new Promise(resolve => {
      try {
        this._storage.get(key).subscribe((data) => {
          resolve(data);
        });
      } catch (error) {
        resolve('');
      }
    });
  }

  // Remove storage data -----------------
  removeStorageData(key) {
    return new Promise(resolve => {
      try {
        this._storage.delete(key).subscribe(() => {
          resolve(true);
        });
      } catch (error) {
        resolve(false);
      }
    });
  }

  // Encrypt Data -----------------
  encryptData(data) {
    try {
      return CryptoJS.AES.encrypt(JSON.stringify(data), environment.encryptSecretKey).toString();
    } catch (e) {
      console.log(e);
      return '';
    }
  }

  // Decrypt Data -----------------
  decryptData(data) {
    try {
      const bytes = CryptoJS.AES.decrypt(data, environment.encryptSecretKey);

      if (bytes.toString()) {
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      } else {
        return data;
      }
    } catch (e) {
      return '';
    }
  }

  // Format mobile number -----------------
  formatmobileNumber(mobileNumber: any) {
    try {
      if(mobileNumber.length < 10) { // Invalid mobile number
        return '';
      } else if(mobileNumber.length == 10) { // Mobile number without country code - Add USA country code
        return '+1' + mobileNumber;
      } else if (mobileNumber.length > 13) { // Invalid mobile number
        return '';
      } else { // Mobile number with country code
        return mobileNumber;
      }
    } catch (e) {
      console.log(e);
      return '';
    }
  }

  // Csv File upload to S3 (NOT USED) -----------------
  /*s3CsvFileUpload(csvData: any, bucket_name: string, folder: string, fileNamePrefix: string){
    return new Promise((resolve, reject) => {
      try {
        const blob = new Blob([csvData], { type: 'text/csv' });
        const s3 = new S3({
          region: environment.s3_region,
          credentials: {
            accessKeyId: environment.aws_key,
            secretAccessKey: environment.aws_secret
          }
        });
        const fileName: string = fileNamePrefix + moment().unix() + '-' + Math.floor(Math.random() * 9999) + '.csv';
        const params = {
          Bucket: bucket_name,
          Key: folder + fileName,
          Body: blob
        };

        s3.putObject(params, function(err, data){
          if (err) {
            // Return error
            const responseError = {
              status: false,
              error: err
            };
            resolve(responseError);
          } else {
            // Return data
            const responseSuccess = {
              status: true,
              data: data,
              fileName: fileName,
              location: 'https://s3-' + environment.s3_region + '.amazonaws.com/' + params.Bucket + '/' + params.Key
            };
            resolve(responseSuccess);
          }
        });
      } catch (err) {
        return reject(err);
      }
    });
  }*/

  // File upload to S3 (NOT USED) -----------------
  /*s3FileUpload(file: any, bucket_name: string, folder: string, fileName: string){
    return new Promise(resolve => {
      const response: any = [];
      const contentType = file.type;
      const bucket = new S3(
        {
          accessKeyId: environment.aws_key,
          secretAccessKey: environment.aws_secret,
          region: environment.s3_region
        }
      );

      // Set file name
      let newFileName: string;
      if (!fileName) { // Set timestamp if file name is missing
        newFileName = moment().unix() + '.' + file.name.split('.')[1];
      } else {
        newFileName = fileName + '.' + file.name.split('.')[1];
      }

      const params = {
        Bucket: bucket_name,
        Key: folder + newFileName, // Add timestamp
        Body: file,
        //ACL: 'public-read', // BLOCKED To FIX ERROR "The bucket does not allow ACLs" (March 6 2025)
        ContentType: contentType
      };

      bucket.upload(params, function (err, data) {
        if (err) {
          // Return error
          const object = {
            'status': false,
            'error': err
          };
          response.push(object);
          resolve(response);
        }else{
          // Return data
          const object = {
            'status': true,
            'data': data
          };
          response.push(object);
          resolve(response);
        }
      });
    });
  }*/

  // base64 to S3 (NOT USED) -----------------
  /*s3Base64Upload(file: any, base64: any, bucket_name: string, folder: string){
    return new Promise((resolve, reject) => {
      try {
        const bucket = new S3({
            accessKeyId: environment.aws_key,
            secretAccessKey: environment.aws_secret,
            region: environment.s3_region
        });

        var imgData = new Buffer(base64.replace(/^data:image\/\w+;base64,/, ""),'base64')

        // Set file name
        let fileName: string = moment().unix() + '-' + Math.floor(Math.random() * 9999) + '.' + file.name.split('.')[1];  // Add timestamp

        var params:any = {
          Bucket: bucket_name,
          Key: folder + fileName,
          Body: imgData,
          ContentEncoding: 'base64',
          ContentType: file.type
        };

        bucket.putObject(params, function(err, data){
            if (err) {
              // Return error
              const responseError = {
                status: false,
                error: err
              };
              resolve(responseError);
            } else {
              // Return data
              const responseSuccess = {
                status: true,
                data: data,
                location: 'https://s3-' + environment.s3_region + '.amazonaws.com/' + params.Bucket + '/' + params.Key
              };
              resolve(responseSuccess);
            }
        });
      } catch (err) {
        return reject(err);
      }
    });
  }*/

  // Conver image file to base64 -----------------
  async imageFiletoBase64(file: File, maxSize: any): Promise<string | ArrayBuffer> {
    return new Promise<string | ArrayBuffer>((resolve, reject) => {
      try {
        const file_size: any = file.size;
        const file_name: any = file.name.split('.');
        const reader = new FileReader();

        if ((file_size / 1024) > maxSize) {
          return reject('Image file size exceeds maximum limit');
        } else if (file_name.length > 2) {
          return reject("Image file name should not have '.' in it");
        } else if (file_name.length === 2 && (file_name[1].toLowerCase() === "jpg" || file_name[1].toLowerCase() === "jpeg" || file_name[1].toLowerCase() === "png")) {
          reader.onload = e => {
            return resolve((e.target as FileReader).result);
          };

          reader.onerror = e => {
            return reject(`FileReader failed on file ${file.name}.`);
          };

          if (!file) {
            return reject('No file to read');
          }

          reader.readAsDataURL(file);
        } else {
          return reject('Invalid image file selected');
        }
      } catch (err) {
        return reject(err);
      }
    });
  }


  // Check user access -----------------
  checkUserAccess(menuCode: any, menuList: any) {
    return new Promise(async resolve => {
      try {
        let menuStatus = _.filter(menuList, item => item.menu_code === menuCode);

        if (menuStatus.length === 0) { // Menu access not found
          resolve(false);
        } else { // Menu access avilable
          resolve(true);
        }
      } catch (error) {
        resolve(false);
      }
    });
  }

  // Retailer logout
  async retailerLogout() {
    let responseRemoveStorageDataC_LOGIN = await this.removeStorageData('R_LOGIN');
    let responseRemoveStorageDataC_RETAILERS = await this.removeStorageData('R_RETAILERS');

    this._router.navigate(['/retailer']);
  }

  // CPG logout
  async cpgLogout() {
    let responseRemoveStorageDataC_LOGIN = await this.removeStorageData('C_LOGIN');
    let responseRemoveStorageDataC_RETAILERS = await this.removeStorageData('C_RETAILERS');
    let responseRemoveStorageDataC_CATEGORIES = await this.removeStorageData('C_CATEGORIES');
    let responseRemoveStorageDataC_MANUFACTURERS = await this.removeStorageData('C_MANUFACTURERS');
    let responseRemoveStorageDataC_BRANDS = await this.removeStorageData('C_BRANDS');

    this._router.navigate(['/cpg']);
  }

  // Distributor logout
  async distributorLogout() {
    let responseRemoveStorageDataC_LOGIN = await this.removeStorageData('D_LOGIN');
    let responseRemoveStorageDataC_RETAILERS = await this.removeStorageData('D_RETAILERS');
    let responseRemoveStorageDataC_CATEGORIES = await this.removeStorageData('D_CATEGORIES');
    let responseRemoveStorageDataC_MANUFACTURERS = await this.removeStorageData('D_MANUFACTURERS');
    let responseRemoveStorageDataC_BRANDS = await this.removeStorageData('D_BRANDS');

    this._router.navigate(['/distributor']);
  }

  // Admin logout
  async adminLogout() {
    let responseRemoveStorageDataA_LOGIN = await this.removeStorageData('A_LOGIN');

    this._router.navigate(['/admin']);
  }

  // Get percentage change between 2 numbers
  getPercentageChange(V1: any, V2: any, remove_negative?: boolean){
    let percentage_change: any = ((parseFloat(V2) - parseFloat(V1)) / parseFloat(V1)) * 100;

    //Set percentage change to zero if V1=0
    if (V1 == 0){
      percentage_change = 0;
    }

    if (remove_negative == false){ //Keep -ve
    }else{ //Remove -ve
      percentage_change = Math.abs(percentage_change);
    }

    return percentage_change;
  }

  // Upload file to cloud storage
  uploadFile(token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/uploadFile';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

}
